import { defineStore } from "pinia";

interface TranslateState {
  languages: string[];
  selectedLanguage: string;
  imageUrl: string
}

export const useTranslateStore = defineStore("translate", {
  state: (): TranslateState => ({
    languages: ["English", "Hindi", "Kannada", "Tamil", "Telugu"],
    selectedLanguage: "English",
    imageUrl: ''
  }),
  actions: {
    setSelectedLanguage(language: string) {
      this.selectedLanguage = language;
    },
    setImageUrl(url: string) {
      this.imageUrl = url
    },
    clearImageUrl() {
      this.imageUrl = ''
    },
    reset() {
      this.selectedLanguage = "English"; // reset language
      this.imageUrl = ''
    }
  },
});

